var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.359,
    height: 88.361,
    viewBox: "0 0 88.359 88.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(23.31 39.407) rotate(-80.78)",
    fill: "#f0585f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238",
    "data-name": "Ellipse 238",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(52.945 38.906) rotate(-76.72)",
    fill: "#f0585f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4133",
    "data-name": "Path 4133",
    d: "M4037.64,533.19a44.18,44.18,0,1,0,44.179,44.18A44.229,44.229,0,0,0,4037.64,533.19Zm39.225,44.18a39.225,39.225,0,1,1-39.225-39.225A39.27,39.27,0,0,1,4076.865,577.37Z",
    transform: "translate(-3993.461 -533.19)",
    fill: "#f0585f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4134",
    "data-name": "Path 4134",
    d: "M4135.083,838.48a29.8,29.8,0,0,0-27.2,17.68,2.478,2.478,0,0,0,4.528,2.014,24.814,24.814,0,0,1,45.353,0,2.478,2.478,0,0,0,4.528-2.014A29.8,29.8,0,0,0,4135.083,838.48Z",
    transform: "translate(-4090.904 -793.672)",
    fill: "#f0585f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "static/media/Bad.8933f186feeefb752c96dda542310dd6.svg";
export { ForwardRef as ReactComponent };